<script>
import {Line} from 'vue-chartjs'

export default {
  extends: Line,
  props: ['labels', 'datasets'],

  mounted() {

    // Render component
    this.renderChart({
          labels: this.labels,
          datasets: this.datasets
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          onClick: this.handleClick,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              }
            }]
          }
        });
  },
  methods: {

    /**
     * Handle click
     * @param point
     * @param event
     */
    handleClick(point, event) {
      const item = event[0]
      this.$emit('item-click', {
        index: item._index,
        label: this.labels[item._index],
      })
    }
  }
}
</script>

<style>
</style>
